import styled, { css } from 'styled-components';

interface NameSuggestionContainerProps {
  visible: boolean;
  delayTimeInMilliseconds?: number;
  backgroundColor: string;
}

export const transitionTimeInMilliseconds = 400;

export const NameSuggestionContainer = styled.div<NameSuggestionContainerProps>`
  width: 100%;
  background: ${(props) => props.backgroundColor};
  border-radius: 4px;
  box-sizing: border-box;
  padding: 1.1rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity ${transitionTimeInMilliseconds}ms ease-in-out;
  opacity: 0;

  ${({ visible }) =>
    visible &&
    css`
      opacity: 1;
    `}
`;

export const NameSuggestionPrefix = styled.span`
  font-weight: 700;
  font-size: 1.25rem;
`;
